var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('div',{staticClass:"auto-logout-wrapper"},[_c('div',{staticClass:"alert alert-danger"},[_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.preventLogout}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "+_vm._s(_vm.$t("autoLogout.hint"))+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }